<!--<div>
  <h6>I want to search for</h6>
  <app-doc-category-ex2></app-doc-category-ex2>
</div>
<div>
  <h6 m-2>The document was created</h6>
  <app-date-range-ps></app-date-range-ps>
</div>
<div>
  <app-compound-name></app-compound-name>
</div>
<div class="col-sm-4 col-container">
  <app-address></app-address>
</div>
<div class="ct-dropdwn"  >
  <app-city-town-ex></app-city-town-ex>
</div>
<button class="btn btn-default" type="button" [routerLink]='["/property-search-result-pg"]'>
  SEARCH RECORDED AND REGISTERED LAND
</button>-->
<div class="rec-container">
  <h2>I want to search for</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">

    <!--<div class="doc-container">
      <app-doc-category-ex2></app-doc-category-ex2>
    </div>-->
    <div class="date-container">
      <!--<app-daterange></app-daterange>-->
      <lib-date-range-parent></lib-date-range-parent>
    </div>
    <div class="name-container">
      <app-compound-name></app-compound-name>
    </div>
    <div class="city-container">
      <app-city-town-ex></app-city-town-ex>
    </div>

    <!--<div class="address-role-container mb-55">
      <div class="address-container">
        <app-compound-address></app-compound-address>
      </div>
      <div class="space"></div>
    </div>-->
    <button class="btn btn-default" type="submit">
      SEARCH
    </button>


    <!--<button class="btn btn-default" type="button" (click)="search('/property-search-result-pg')">
    SEARCH RECORDED AND REGISTERED LAND
  </button>-->
  </form>
</div>

